import {mainQuery} from '@github-ui/react-core/future/main-query'
import {queryFnFetch} from '@github-ui/react-core/future/query-fn-fetch'
import {issuesAppBuilder} from '../config/app-builder'
import {ISSUES_DASHBOARD_PATH} from '../constants/routes'
import {issuesQueryResolver} from '../helpers/issues-query-resolver'

import type {IssuesDashboardDeferredDataPayload, IssuesDashboardSurfacePayload} from '../types/routes-types'

export const issuesDashboardSurfaceContentRoute = issuesAppBuilder.createQueryRouteConfig(
  'issuesDashboardSurfaceContentRoute',
  {
    path: `${ISSUES_DASHBOARD_PATH}/:mode`,
    queries: [
      mainQuery<IssuesDashboardSurfacePayload>({
        queryDeps: ({searchParams, params}: {searchParams: URLSearchParams; params: {mode?: string}}) => {
          const q = issuesQueryResolver({searchParams, params})
          return {
            pathname: ISSUES_DASHBOARD_PATH,
            searchParams: {q, page: searchParams.get('page') || '1'},
          }
        },
      }),
      {
        queryName: 'deferred',
        queryDeps: ({searchParams, params}) => {
          const q = issuesQueryResolver({searchParams, params})
          return {
            pathname: `${ISSUES_DASHBOARD_PATH}/deferred`,
            searchParams: {q, page: searchParams.get('page') || '1'},
          }
        },
        queryFn: async queryKey => queryFnFetch<IssuesDashboardDeferredDataPayload>(queryKey),
      },
    ],
  },
)
